import Helper from '../../../models/Helper';

const URI = '/availabilities/:id';

/**
 * @desc Helper for availabilities.
 */
class AvailabilitiesHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }
}

export default AvailabilitiesHelper;
